export enum Session {
  SELECT_LANGUAGE = 'session/selectLanguage',
  GET_LOCATION_REQUEST = 'session/getLocationRequest',
  GET_LOCATION_FULFILLED = 'session/getLocationFulfilled',
  GET_LOCATION_REJECTED = 'session/getLocationRejected',
  SET_SHOW_WELCOME_MESSAGE = 'session/setShowWelcomeMessage',
}
